import Resizer from 'react-image-file-resizer';

function filterImg(img: String): (string | undefined) {
  if (img.includes('jpeg')) {
    return img.replace('data:image/jpeg;base64,', '');
  }
  if (img.includes('png')) {
    return img.replace('data:image/png;base64,', '');
  }
  return undefined;
}
const resizeImage = (file: File) => new Promise((resolve) => {
  Resizer.imageFileResizer(
    file,
    250,
    250,
    'PNG',
    100,
    0,
    (uri) => {
      resolve(uri);
    },
    'file',
    250,
    250,
  );
});
const convertImageBase64 = (file: any) => new Promise((resolve) => {
  Resizer.imageFileResizer(
    file,
    400,
    400,
    'PNG',
    100,
    0,
    (uri) => {
      resolve(uri);
    },
    'base64',
    400,
    400,
  );
});
export default {
  filterImg,
  resizeImage,
  convertImageBase64,
};
